import VueRouter from 'vue-router'
import VueMultiGuard from 'vue-router-multiguard';
import Multiguard from 'vue-router-multiguard';
import firebase from 'firebase'
import { Message, Loading } from 'element-ui';


// let currentUser=firebase.auth().currentUser;
let routes = [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "guest-page" */'../layouts/guest-page'),

        children: [
          
            {
                path: '/',
                alias: '/login',
                component: () => import(/* webpackChunkName: "auth.login" */'../views/auth/login')
            },
        ]
    },

    {
       path: '/',
        component: () => import(/* webpackChunkName: "default-page-bp" */'../layouts/default-page-bp'),

        children: [

            {
                path: '/blank',
                component: () => import(/* webpackChunkName: "pages.blank" */'../views/pages/blank')
            },
            {
                path: '/configuration',
                component: () => import(/* webpackChunkName: "configuration.configuration" */'../views/configuration/configuration')
            },
            {
                path: '/profile',
                component: () => import(/* webpackChunkName: "user.profile" */'../views/user/profile')
            },
         
            {
                path: '/user',
                component: () => import(/* webpackChunkName: "user.index" */'../views/user/index')
            },
        ]
    },
    {
        path: '/',
        component: () => import(/* webpackChunkName: "default2-page-bp" */'../layouts/default2-page-bp'),

        children: [

            {
                meta: { requiresAuth: true, windowRedirectAfter: true },
                path: '/bp/projets',
                component: () => import(/* webpackChunkName: "bp.selection-projet" */'../views/bp/selection-projet'),
                name: "projets",
                beforeEnter: VueMultiGuard([isLoggedAsParticipant, accessProjetsInterneListe])
            },
            // {
            //     meta: { requiresAuth: true },
            //     path: '/bp/soumission/projets',
            //     component: () => import(/* webpackChunkName: "admin.concours.soumissionProjet" */'../views/admin/concours/soumissionProjet'),
            //     name: 'soumission-projet',
            //     beforeEnter: VueMultiGuard([isLoggedAsParticipant])

            // },
            {
                meta: { requiresAuth: true },
                path: '/bp/profile/user',
                component: () => import(/* webpackChunkName: "bp.profile.user" */'../views/bp/profile/user'),
                beforeEnter: VueMultiGuard([isLoggedAsParticipant, accessLogoEntreprise])
            },

        ]
    },
    {
        path: '/',
        component: () => import(/* webpackChunkName: "default-suivi-page" */'../layouts/default-suivi-page'),
        children: [

            {
                meta: { requiresAuth: true, windowRedirectAfter: true },
                path: '/bp/suivi',

                component: () => import(/* webpackChunkName: "suivi.home" */'../views/suivi/home'),

                name: 'suivi-home'
            },
            {
                meta: { requiresAuth: true },
                path: '/bp/suivi/dashboard',
                component: () => import(/* webpackChunkName: "suivi.suivi" */'../views/suivi/finances/dashboard'),
                name: 'suivi-dashboard',
            },
            {
                meta: { requiresAuth: true },
                path: '/bp/suivi/recettes',
                component: () => import(/* webpackChunkName: "suivi.finances.recette" */'../views/suivi/finances/recette'),
                name: 'suivi-recettes',
                beforeEnter: Multiguard([isLoggedAsParticipant, accessRecette])
            },
            {
                meta: { requiresAuth: true },
                path: '/bp/suivi/depenses',
                component: () => import(/* webpackChunkName: "suivi.finances.depenses" */'../views/suivi/finances/depenses'),
                name: 'suivi-depenses',
                beforeEnter: Multiguard([isLoggedAsParticipant, accessDepense])
            },
            {
                meta: { requiresAuth: true },
                path: '/bp/suivi/soldes',
                component: () => import(/* webpackChunkName: "suivi.finances.soldes" */'../views/suivi/finances/soldes'),
                name: 'suivi-soldes',
                beforeEnter: Multiguard([isLoggedAsParticipant, accessSoldes])
            },
            {
                path: '/bp/suivi/devis',
                component: () => import(/* webpackChunkName: "suivi.devis.devis" */'../views/suivi/devis/creer-devis'),
                name: 'Devis'
            },
               {
                path: '/bp/suivi/devis/liste',
                component: () => import(/* webpackChunkName: "suivi.devis.devis" */'../views/suivi/devis/devis'),
                name: 'devis-list'
            },
            {
                path: '/bp/suivi/devis/model/:id',
                component: () => import(/* webpackChunkName: "suivi.devis.parametre-devis" */'../views/suivi/devis/parametre-devis'),
                name: 'model-devis'
            },
            {
                path: '/bp/suivi/devis/model/nouveau',
                component: () => import(/* webpackChunkName: "suivi.devis.parametre-devis" */'../views/suivi/devis/parametre-devis'),
                name: 'nouveau-model-devis'
            },
            {
                path: '/bp/suivi/devis/statistiques',
                component: () => import(/* webpackChunkName: "suivi.devis.statistiques" */'../views/suivi/devis/statistiques'),
                name: 'devis-statistiques'
            },
            {
                path: '/bp/suivi/devis/operations',
                component: () => import(/* webpackChunkName: "suivi.devis.operations" */'../views/suivi/devis/operations'),
                name: 'devis-operations'
            },
            {
                path: '/bp/suivi/devis/:id',
                component: () => import(/* webpackChunkName: "suivi.devis.formulaire-devis" */'../views/suivi/devis/formulaire-devis'),
                name: 'FormulaireDevis',
                props: true
            },
        
            // {
            //     path: '/bp/suivi/board',
            //     component: () => import(/* webpackChunkName: "suivi.taches.board" */'../views/suivi/taches/board'),
            //     name: 'suivi-board'
            // },
            {
                path: '/bp/suivi/produits',
                component: () => import(/* webpackChunkName: "suivi.parametres.produits" */'../views/suivi/parametres/produits'),
                name: 'suivi-produits'
            },
            {
                path: '/bp/suivi/vendeurs',
                component: () => import(/* webpackChunkName: "suivi.parametres.vendeurs" */'../views/suivi/parametres/vendeurs'),
                name: 'suivi-vendeurs'
            },
            {
                path: '/bp/suivi/clients',
                component: () => import(/* webpackChunkName: "suivi.parametres.clients" */'../views/suivi/parametres/clients'),
                name: 'suivi-clients'
            },
            {
                path: '/bp/suivi/pays',
                component: () => import(/* webpackChunkName: "suivi.parametres.pays" */'../views/suivi/parametres/pays'),
                name: 'suivi-pays'
            },
            {
                path: '/bp/suivi/categories',
                component: () => import(/* webpackChunkName: "suivi.parametres.categories" */'../views/suivi/parametres/categories'),
                name: 'suivi-categories'
            },
            {
                path: '/bp/suivi/fisc',
                component: () => import(/* webpackChunkName: "suivi.fisc.home" */'../views/suivi/fisc/home'),
                name: 'suivi-fisc'
            },
            {
                path: '/bp/suivi/fisc/banques',
                component: () => import(/* webpackChunkName: "suivi.fisc.banques" */'../views/suivi/fisc/banques'),
                name: 'suivi-fisc-banque'
            },
            {
                path: '/bp/suivi/acteurs',
                component: () => import(/* webpackChunkName: "suivi.acteurs.home" */'../views/suivi/acteurs/home'),
                name: 'suivi-acteurs'
            },
            {
                path: '/bp/suivi/acteurs/clients',
                component: () => import(/* webpackChunkName: "suivi.acteurs.clients" */'../views/suivi/acteurs/clients'),
                name: 'suivi-acteurs-clients'
            },
            {
                path: '/bp/suivi/acteurs/vendeurs',
                component: () => import(/* webpackChunkName: "suivi.acteurs.clients" */'../views/suivi/acteurs/vendeur'),
                name: 'suivi-acteurs-vendeurs'
            },
            {
                path: '/bp/suivi/acteurs/fournisseurs',
                component: () => import(/* webpackChunkName: "suivi.acteurs.fournisseurs" */'../views/suivi/acteurs/fournisseurs'),
                name: 'suivi-acteurs-fournisseurs'
            },
            {
                path: '/bp/suivi/acteurs/membres',
                component: () => import(/* webpackChunkName: "suivi.acteurs.membres" */'../views/suivi/acteurs/membres'),
                name: 'suivi-acteurs-membres'
            },
            {
                path: '/bp/suivi/acteurs/roles',
                component: () => import(/* webpackChunkName: "suivi.acteurs.roles" */'../views/suivi/acteurs/roles'),
                name: 'suivi-acteurs-roles'
            },
            {
                path: '/bp/suivi/parametres/formulaires/recettes',
                component: () => import(/* webpackChunkName: "suivi.parametres.formulaires.recettes" */'../views/suivi/parametres/formulaires/recettes'),
                name: 'suivi-parametres-formulaires-recettes'
            },
            {
                path: '/bp/suivi/parametres/formulaires/depenses',
                component: () => import(/* webpackChunkName: "suivi.parametres.formulaires.depenses" */'../views/suivi/parametres/formulaires/depenses'),
                name: 'suivi-parametres-formulaires-depenses'

            },
            {
                path: '/bp/suivi/parametres/formulaires/fiscalite',
                component: () => import(/* webpackChunkName: "errors.construction" */'../views/errors/construction'),
                props: {
                    title: 'Fiche d\'evaluation en cours de construction',
                    link: 'https://forms.gle/c49f9WbBYX4vBdaj7'
                },
                name: 'suivi-parametres-formulaires-fiscalite'
            },
            {
                path: '/bp/suivi/objectif',
                component: () => import(/* webpackChunkName: "errors.construction" */'../views/errors/construction'),
                props: {
                    title: 'Gestion des objectifs en cours de construction',
                    link: 'https://forms.gle/c49f9WbBYX4vBdaj7'
                },
                name: 'suivi-objectif'
            },
            {
                path: '/bp/suivi/parametres/formulaire',
                component: () => import(/* webpackChunkName: "errors.construction" */'../views/errors/construction'),
                props: {
                    title: 'Cette page est en cours de construction',
                    link: 'https://forms.gle/c49f9WbBYX4vBdaj7'
                },
            },
            {
                path: '/bp/suivi/parametres/fiscalite',
                component: () => import(/* webpackChunkName: "errors.construction" */'../views/errors/construction'),
                props: {
                    title: 'Cette page est en cours de construction',
                    link: 'https://forms.gle/c49f9WbBYX4vBdaj7'
                },
            },
          
          
        ]
    },


 
    {
        path: '*',
        component: () => import(/* webpackChunkName: "error-page" */'../layouts/error-page'),
        children: [
            {
                path: '*',
                component: () => import(/* webpackChunkName: "page-not-found" */'../views/errors/page-not-found')
            }
        ]
    }
];

const router = new VueRouter({
    routes,
    linkActiveClass: 'active',
    mode: 'history'
});

async function accessProjetsInterneListe(to, from, next) {

    let userSession = JSON.parse(localStorage.getItem('userSession'));
    userSession.projet = '';
    userSession.projettitre = '';
    //Admin perm
    localStorage.setItem('userSession', JSON.stringify(userSession));
    firebase.firestore().collection('users').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
        let obj = doc.data();
        if (obj.adminId) {

            obj.roleId.get().then(roleUser => {
                let perm = roleUser.data().permissions.admin;
                perm.forEach(item => {
                    if (item.haschildren == true) {
                        //    console.log(item.haschildren)
                        item.content.forEach(itemcontent => {
                            if (itemcontent.route == 'projets') {
                                if (itemcontent.checked) {

                                    to.params.data = itemcontent.value
                                    next()
                                    // console.log(itemcontent.checked)
                                }
                                else {
                                    // console.log('Bad')
                                    Message.warning({
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
                                    })

                                }

                            }

                        })
                    }


                })


            })
        }
        else {
            Loading.service({ fullscreen: true });

            let userSession = JSON.parse(localStorage.getItem('userSession'));
            userSession.projet = '';
            userSession.projettitre = '';
            //Admin perm
            localStorage.setItem('userSession', JSON.stringify(userSession));
            firebase.firestore().collection('permissions').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
                let obj = doc.data()
                //  console.log('Mon Log',doc.data())
                let perm = doc.data().admin;
                perm.forEach(item => {
                    if (item.haschildren == true) {

                        item.content.forEach(itemcontent => {
                            if (itemcontent.route == 'projets') {

                                if (itemcontent.checked) {

                                    to.params.data = itemcontent.value
                                    next()
                                    // console.log(itemcontent.checked)
                                }
                                else {
                                    // console.log('Bad')
                                    Message.warning({
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
                                    })

                                }

                            }

                        })
                    }


                })

            })

        }


    })
}




function accessLogoEntreprise(to, from, next) {
    Loading.service({ fullscreen: true });
    firebase.firestore().collection('users').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
        let obj = doc.data();
        if (!obj.adminId) {

            let accesslogo = {
                logoEntreprise: {
                    'value': true
                }
            }
            to.params.data = accesslogo
            to.params.user = obj
            next()
        }
        else {

            let accesslogo = {
                logoEntreprise: {
                    'value': false
                }
            }
            to.params.data = accesslogo

            next()
        }


    })
}


function isLoggedAsParticipant(to, from, next) {
    Loading.service({ fullscreen: true });
    if (to.meta.requiresAuth) {
        let userInfo = JSON.parse(localStorage.getItem("userSession"))
        if (userInfo.profile == '3' || userInfo.profile == '4') {

            next()
        }
        else {
            // console.log('Bad')
            Message.warning({
                dangerouslyUseHTMLString: true,
                message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
            })
        }
    }
}

router.beforeEach((to, from, next) => {
    Loading.service({ fullscreen: true });
    let matchedObject = from.matched.slice().reverse().find(r => r.meta && r.meta.hasOwnProperty('windowRedirectAfter'));
    // $loading({fullscreen:true})
    //  let loadingInstance=Loading.service({ fullscreen: true });
    if (matchedObject) {
        if (matchedObject.meta.windowRedirectAfter === true) {
            window.location.href = to.fullPath;
            return;
        }
    }
    if (to.meta.requiresAuth) {
        firebase.firestore().collection('users').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
            let obj = doc.data();
            let currentuser = firebase.auth().currentUser
            // console.log('Displayname',currentuser.displayName)
            obj.displayName = currentuser.displayName
            // console.log('Objet',obj)
            to.params.user = obj
            to.params.displayName = currentuser.displayName
            return next()
        })
    } else {
        return next()
    }



});

//PERMISSION SUIVI
function accessRecette(to, from, next) {
    firebase.firestore().collection('users').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
        let obj = doc.data();
        if (obj.adminId && !obj.idConcours) {
            Loading.service({ fullscreen: true });
            obj.roleId.get().then(roleUser => {
                let perm = roleUser.data().permissions.suivi;
                perm.forEach(item => {
                    if (item.haschildren == true) {
                        //    console.log(item.haschildren)
                        item.content.forEach(itemcontent => {
                            if (itemcontent.route == 'suivi-recettes') {
                                if (itemcontent.checked) {

                                    to.params.data = itemcontent.value
                                    next()
                                    // console.log(itemcontent.checked)
                                }
                                else {
                                    // console.log('Bad')
                                    Message.warning({
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
                                    })

                                }

                            }

                        })
                    }


                })


            })
        }
        if (!obj.adminId || obj.idConcours) {
            Loading.service({ fullscreen: true });
            firebase.firestore().collection('permissions').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
                let obj = doc.data()
                console.log('Mon Log', doc.data())
                let perm = doc.data().suivi;
                perm.forEach(item => {
                    if (item.haschildren == true) {
                        //    console.log(item.haschildren)
                        item.content.forEach(itemcontent => {
                            if (itemcontent.route == 'suivi-recettes') {
                                if (itemcontent.checked) {

                                    to.params.data = itemcontent.value
                                    next()
                                    // console.log(itemcontent.checked)
                                }
                                else {
                                    // console.log('Bad')
                                    Message.warning({
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
                                    })

                                }

                            }

                        })
                    }


                })

            })

        }


    })


}
function accessDepense(to, from, next) {
    firebase.firestore().collection('users').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
        let obj = doc.data();
        if (obj.adminId && !obj.idConcours) {
            Loading.service({ fullscreen: true });
            obj.roleId.get().then(roleUser => {
                let perm = roleUser.data().permissions.suivi;
                perm.forEach(item => {
                    if (item.haschildren == true) {
                        //    console.log(item.haschildren)
                        item.content.forEach(itemcontent => {
                            if (itemcontent.route == 'suivi-depenses') {
                                if (itemcontent.checked) {

                                    to.params.data = itemcontent.value
                                    next()
                                    // console.log(itemcontent.checked)
                                }
                                else {
                                    // console.log('Bad')
                                    Message.warning({
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
                                    })

                                }

                            }

                        })
                    }


                })


            })
        }
        if (!obj.adminId || obj.idConcours) {
            Loading.service({ fullscreen: true });
            firebase.firestore().collection('permissions').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
                let obj = doc.data()
                console.log('Mon Log', doc.data())
                let perm = doc.data().suivi;
                perm.forEach(item => {
                    if (item.haschildren == true) {
                        //    console.log(item.haschildren)
                        item.content.forEach(itemcontent => {
                            if (itemcontent.route == 'suivi-depenses') {
                                if (itemcontent.checked) {

                                    to.params.data = itemcontent.value
                                    next()
                                    // console.log(itemcontent.checked)
                                }
                                else {
                                    // console.log('Bad')
                                    Message.warning({
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
                                    })

                                }

                            }

                        })
                    }


                })

            })

        }


    })


}

function accessSoldes(to, from, next) {
    firebase.firestore().collection('users').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
        let obj = doc.data();
        if (obj.adminId && !obj.idConcours) {
            Loading.service({ fullscreen: true });
            obj.roleId.get().then(roleUser => {
                let perm = roleUser.data().permissions.suivi;
                perm.forEach(item => {
                    if (item.haschildren == true) {
                        //    console.log(item.haschildren)
                        item.content.forEach(itemcontent => {
                            if (itemcontent.route == 'suivi-soldes') {
                                if (itemcontent.checked) {

                                    to.params.data = itemcontent.value
                                    next()
                                    // console.log(itemcontent.checked)
                                }
                                else {
                                    // console.log('Bad')
                                    Message.warning({
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
                                    })

                                }

                            }

                        })
                    }


                })


            })
        }
        if (!obj.adminId || obj.idConcours) {
            Loading.service({ fullscreen: true });
            firebase.firestore().collection('permissions').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
                let obj = doc.data()
                console.log('Mon Log', doc.data())
                let perm = doc.data().suivi;
                perm.forEach(item => {
                    if (item.haschildren == true) {
                        //    console.log(item.haschildren)
                        item.content.forEach(itemcontent => {
                            if (itemcontent.route == 'suivi-soldes') {
                                if (itemcontent.checked) {

                                    to.params.data = itemcontent.value
                                    next()
                                    // console.log(itemcontent.checked)
                                }
                                else {
                                    // console.log('Bad')
                                    Message.warning({
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
                                    })

                                }

                            }

                        })
                    }


                })

            })

        }


    })


}

function accessBpHome(to, from, next) {
    firebase.firestore().collection('users').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
        let obj = doc.data();
        Loading.service({ fullscreen: true });
        if (obj.adminId) {
            if (obj.roleId) {

                obj.roleId.get().then(roleUser => {
                    let perm = roleUser.data().permissions;
                    to.params.data = perm
                    next()


                })
            }

        }
        if (obj.idConcours) {
            Loading.service({ fullscreen: true });
            firebase.firestore().collection('permissions').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
                let obj = doc.data()
                let perm = doc.data();
                if (perm.executiveSummary.state) {
                    to.params.data = perm
                    next()

                }
                else {
                    // next({path:from.path})
                    // console.log('route courante',this.$route.path)
                    Message.warning({
                        dangerouslyUseHTMLString: true,
                        message: '<strong>Vous n\'avez pas les droits d\'accès à cette ressource</strong> ',
                    })
                }

            })

        }
        if (!obj.adminId) {
            Loading.service({ fullscreen: true });
            firebase.firestore().collection('permissions').doc(JSON.parse(localStorage.getItem("userSession")).uid).get().then((doc) => {
                let obj = doc.data()
                console.log('Mon Log', doc.data())
                let perm = doc.data();
                to.params.data = perm
                next()

            })

        }

    })


}

export default router;
